import { HttpHeaders } from '@angular/common/http';

export const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json"
  })
};
const targetUrl = "https://ros.com.sg";
// const targetUrl = "https://ros.com.sg/demo";
// export const imgUrl =  "/demo/rosapi/";
// export const imgUrl = "/api/rosapi/";

// production url add before baseurl
// export const baseUrl = "/demo/rosapi/";
// local
export const baseUrl = targetUrl + "/api/rosapi/";

export const imgUrl = baseUrl;
